import { j as t } from "../../_virtual/jsx-runtime.js";
const L = ({
  width: o = 20,
  height: r = 20,
  viewBox: n = "0 0 20 20",
  fill: s = "currentColor",
  ...C
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    width: o,
    height: r,
    viewBox: n,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...C,
    children: /* @__PURE__ */ t.jsx(
      "path",
      {
        d: "M16.4822 3.5182C18.4348 5.47082 18.4348 8.63667 16.4822 10.5892L10.5896 16.4818C8.63693 18.4344 5.47113 18.4344 3.51851 16.4818C1.56589 14.5292 1.56589 11.3634 3.51851 9.41075L9.41109 3.5182C11.3637 1.56557 14.5295 1.56557 16.4822 3.5182ZM11.7687 12.9457L7.05463 8.23165L4.69703 10.5892C3.39528 11.891 3.39528 14.0016 4.69703 15.3033C5.99877 16.6051 8.10932 16.6051 9.41109 15.3033L11.7687 12.9457ZM15.3036 4.69671C14.0018 3.39496 11.8913 3.39496 10.5896 4.69671L8.23314 7.05314L12.9472 11.7672L15.3036 9.41075C16.6053 8.10901 16.6053 5.99846 15.3036 4.69671Z",
        fill: s
      }
    )
  }
);
export {
  L as default
};
